import { createSelector } from '@ngrx/store';
import { BoelsState, getStoreState } from '../../reducers.index';
import { HolidaysState } from '../reducers/holidays.reducer';

export const selectHolidaysState = createSelector(
  getStoreState,
  (state: BoelsState) => state.holidays,
);

export const selectHolidays = createSelector(
  selectHolidaysState,
  (state: HolidaysState) => state.holidays,
);

export const selectLoading = createSelector(
  selectHolidaysState,
  (state: HolidaysState) => state.loading,
);

export const selectSuccess = createSelector(
  selectHolidaysState,
  (state: HolidaysState) => state.success,
);

export const selectError = createSelector(
  selectHolidaysState,
  (state: HolidaysState) => state.error,
);
